/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import React from "react";
import { StyledText } from "../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { colors } from "./colors";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClose?: () => void;
  children: React.ReactNode;
  backgroundColor?: string;
  borderColor?: string;
  additionalStyles?: SerializedStyles | SerializedStyles[];
}

const textStyle = css`
  color: ${colors.textSecondary};
  cursor: pointer;
  &:hover {
    color: ${colors.textPrimary};
  }
`;

export const SmallBadge = ({
  onClose,
  children,
  backgroundColor,
  borderColor,
  additionalStyles,
  ...rest
}: Props) => {
  const badgeStyle = css`
    display: flex;
    flex-direction: row;
    padding: 2px 4px;
    border-radius: 4px;
    align-items: center;
    gap: 8px;
    width: max-content;
    background: ${backgroundColor || colors.whiteHover};
    border: solid 1px ${borderColor || colors.greyBorder};
    ${additionalStyles}
  `;
  return (
    <div css={badgeStyle} {...rest}>
      {children}
      {onClose && (
        <StyledText
          css={textStyle}
          className="bodySubtextRegular mb-0"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={solid("xmark")} />
        </StyledText>
      )}
    </div>
  );
};
